export const HeaderTabelTransportation = [
  'Transportation Partner Name',
  'Address',
  'Region',
  'City',
  'Phone Number',
  'Category',
  'Action',
];
